module.exports = __webpack_public_path__ + "static/media/alertlilogo.f4b0de91.svg";